import Swiper, { Navigation, Pagination, Lazy } from "swiper";
Swiper.use([Pagination, Navigation, Lazy]);

const initStatusSlider = () => {
  const slider = document.querySelector(".status__slider");

  slider &&
    new Swiper(slider, {
      autoHeight: true,
      loop: false,
      lazy: true,
      spaceBetween: 20,
      slidesPerView: 1,
      navigation: {
        nextEl: ".status-navigation-next",
        prevEl: ".status-navigation-prev",
        type: "fraction",
      },
      pagination: {
        el: ".status-navigation__pagination",
        type: "fraction",
      },
    });
};

export default initStatusSlider;
